import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, input, InputSignal } from '@angular/core';
import { NewChatBotComponent } from 'src/chatbot/chatbot.component';
import { DataChatService } from 'src/chatbot/service/dataChat.service';

@Component({
  selector: 'app-chatbot-custom-route-desktop',
  standalone: true,
  imports: [
    NgClass,
    NewChatBotComponent
  ],
  templateUrl: './chatbot-custom-route-desktop.component.html',
  styleUrls: ['./chatbot-custom-route-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatbotCustomRouteDesktopComponent  {
  // Input signals
  public chatID: InputSignal<string> = input.required<string>(); 
   
  // Service injections
  public dataChatService = inject(DataChatService);
  
  // State service signals
  protected isFullScreen = this.dataChatService.isFullScreen;

  // Methods
  toggleChatView(){
      this.dataChatService.hideChat.update(prev => !prev)
  }
}
